import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ Register Service Worker
// if ("serviceWorker" in navigator) {
//     window.addEventListener("load", () => {
//         navigator.serviceWorker
//             .register("/service-worker.js", {
//                 updateViaCache: "none",
//             })
//             .then((reg) => {
//               //  console.log("✅ Service Worker registered:", reg);

//                 // Check for updates every hour
//                 setInterval(() => {
//                     reg.update();
//                 }, 60 * 60 * 1000); // 1 hour

//                 // 🆕 Detect if a new service worker is found
//                 reg.onupdatefound = () => {
//                     const installingWorker = reg.installing;

//                     installingWorker.onstatechange = () => {
//                         if (installingWorker.state === "installed") {
//                             if (navigator.serviceWorker.controller) {
//                                 // New content available - old SW is controlling now
//                                // console.log("🔁 New version available. Reloading page...");
                                
//                                 // Automatically reload the page to get the new version
//                                 window.location.reload();
//                             } else {
//                                 // First time SW install
//                               //  console.log("📦 Content is cached for offline use.");
//                             }
//                         }
//                     };
//                 };

//                 // Listen for messages from service worker
//                 navigator.serviceWorker.addEventListener('message', (event) => {
//                     if (event.data && event.data.type === 'SW_UPDATED') {
//                        // console.log('🔄 Service Worker updated:', event.data.message);
//                         // Automatically reload to get fresh content
//                         window.location.reload();
//                     }
//                 });
//             })
//             .catch((err) => {
//                // console.error("❌ Service Worker registration failed:", err);
//             });
//     });
// }




